'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBorderBottom = function MdBorderBottom(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.4 25v3.4h-3.4v-3.4h3.4z m-3.4 10v-3.4h30v3.4h-30z m3.4-16.6v3.2h-3.4v-3.2h3.4z m23.2-3.4v-3.4h3.4v3.4h-3.4z m0-10h3.4v3.4h-3.4v-3.4z m-23.2 6.6v3.4h-3.4v-3.4h3.4z m23.2 16.8v-3.4h3.4v3.4h-3.4z m0-6.8v-3.2h3.4v3.2h-3.4z m-3.2-16.6v3.4h-3.4v-3.4h3.4z m-6.8 0v3.4h-3.2v-3.4h3.2z m6.8 13.4v3.2h-3.4v-3.2h3.4z m-6.8-6.8v3.4h-3.2v-3.4h3.2z m-13.2-6.6v3.4h-3.4v-3.4h3.4z m13.2 13.4v3.2h-3.2v-3.2h3.2z m-6.6-13.4v3.4h-3.4v-3.4h3.4z m6.6 20v3.4h-3.2v-3.4h3.2z m-6.6-6.6v3.2h-3.4v-3.2h3.4z' })
        )
    );
};

exports.default = MdBorderBottom;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/border-bottom.js
// module id = 2107
// module chunks = 0